<template>
  <li class="nav-item" :class="'layer' + layer">
    <div class="nav-item-text" @click="navClick(data)">
      <i v-if="layer === 1 && data.icon" :class="['shuke', data.icon]"></i>
      {{ data.name }}
    </div>
    <ul v-if="data.children && data.children.length > 0" class="nav-item-ul">
      <nav-item
        v-for="(item, childIndex) in data.children"
        :key="childIndex"
        :data="item"
        :layer="layer + 1"
        :index="childIndex"
        :parentData="data"
        @pageSkip="pageSkip"
      ></nav-item>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'NavItem',
  props: {
    data: Object,
    layer: Number,
    index: {
      type: Number,
      default: 0
    },
    parentData: {
      type: Object,
      default: null
    }
  },
  methods: {
    navClick(route) {
      if (route.path) {
        if (route.path.indexOf('http') !== -1) {
          window.open(route.path, '_blank')
          this.$emit('pageSkip')
          return
        }
        
        const urlParts = route.path.split('?')
        const path = urlParts[0]
        const query = {}
        
        if (urlParts.length > 1) {
          const queryString = urlParts[1]
          const params = new URLSearchParams(queryString)
          
          for (const [key, value] of params) {
            query[key] = value
          }
        }
        
        const currentRoute = this.$router.currentRoute
        const isSameRoute = currentRoute.path === path && 
          JSON.stringify(currentRoute.query) === JSON.stringify(query)
        
        if (!isSameRoute) {
          this.$router.push({
            path: path,
            query: query
          })
        }
        
        this.$emit('pageSkip')
      }
    },
    pageSkip() {
      this.$emit('pageSkip')
    }
  }
}
</script>

<style scoped>
.pc-box .nav-item-container .layer1 {
  font-size: 15px;
  margin: 20px 1%;
  width: 23%;
  box-sizing: border-box;
  text-align: left;
}

.pc-box .nav-item-container .layer1 .nav-item-text {
  border-bottom: 1px solid #e4e6eb;
  padding-bottom: 15px;
  color: #333333;
  font-size: 15px;
  font-weight: 600;
}

.pc-box .nav-item-container .layer1 .nav-item-text i {
  font-weight: normal;
  font-size: 16px;
  margin-right: 8px;
  color: #0055aa;
}

.pc-box .nav-item-container .layer1:hover > .nav-item-text {
  color: #eb580e;
}

.pc-box .nav-item-container .layer1:hover > .nav-item-text i {
  color: #eb580e;
}

.pc-box .nav-item-container .layer2 .nav-item-text {
  border-bottom: none;
  font-weight: normal;
  font-size: 14px;
  float: left;
}

.pc-box .nav-item-container .layer2:hover .nav-item-text {
  color: #eb580e;
  font-weight: normal;
}

.nav-item {
  width: 100%;
  height: auto;
}

.nav-item ul {
  display: none;
  text-indent: 1.58em;
  margin-top: 10px;
  height: 40px;
}

.nav-item:hover .nav-item-ul,
.nav-item .nav-item-text:hover + .nav-item-ul {
  display: block;
}

.nav-item ul li {
  transition: max-height 0.3s ease;
  width: auto;
  line-height: 40px;
}

.nav-item:hover ul li {
  transition: all 0.3s ease;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/NavMenu/NavItem.vue